import React from 'react';
import './login.scss'
import VLogo from "../../assets/img/v-logo.png";
import frontlineLogo from "../../assets/img/frontlineio-logo.svg";
import {Button} from "@mui/material";
import {useStores} from "../../Hooks";


export default function WaitingWorkspace() {
    const {generalStore} = useStores();
    

    return (
        <div className='on-boarding-container'>
            <img src={frontlineLogo} alt='' className='logo'/>
            {/*<LanguageMenu onBoarding={true}/>*/}
            <div className='on-boarding-box-container waiting-workspace'>
                <div className='v-logo-container'>
                    <img alt='v-logo' src={VLogo}/>
                </div>
                <div className='waiting-workspace-title'>
                    {generalStore.translate('yourWorkspaceIsNowPendingApproval')}
                </div>
                <div className='waiting-workspace-text'>
                    {generalStore.translate('createdWorkspaceSentence1')}&nbsp;
                    <a href='https://frontline.io'>{generalStore.translate('createdWorkspaceLink')}</a>&nbsp;{generalStore.translate('createdWorkspaceSentence2')}
                </div>
                <div className='waiting-workspace-text'>
                    {generalStore.translate('cantWait')}&nbsp;<a href='https://frontline.io/contact/'>{generalStore.translate('contactUs')}</a>
                </div>
                <div className='ok-button-container'>
                    <Button onClick={() => window.location.href = 'https://frontline.io/'}>
                        {generalStore.translate('ok')}
                    </Button>
                </div>
            </div>
        </div>
    );
}
